
export const prefix = (modulePrefix: string, translations: object): object => {
    const result = {};

    Object.keys(translations).forEach((key: string) => {
        result[`${modulePrefix}.${key}`] = translations[key];
    });

    return  result;
};


// WEBPACK FOOTER //
// ./src/utils/Lang.ts